import React, { createContext, useContext, useState, ReactNode } from 'react'

interface BasicDropdownContextType {
  openDropdownId: string | null
  setOpenDropdownId: (id: string | null) => void
}

const BasicDropdownContext = createContext<BasicDropdownContextType>({
  openDropdownId: null,
  setOpenDropdownId: () => null,
})

export const BasicDropdownProvider = ({
  children,
}: {
  children: ReactNode
}): JSX.Element => {
  const [openDropdownId, setOpenDropdownId] = useState<string | null>(null)

  return (
    <BasicDropdownContext.Provider
      value={{ openDropdownId, setOpenDropdownId }}
    >
      {children}
    </BasicDropdownContext.Provider>
  )
}

export const useBasicDropdown = (): BasicDropdownContextType => {
  return useContext(BasicDropdownContext)
}
